export const HOME_TRACK_EVENT = "Page d'accueil {{extend}}";
